// Mock data pour le site de marabout africain

export const cities = [
  { 
    id: 'paris', 
    name: 'Paris',
    slug: 'paris',
    surroundingCities: ['Boulogne-Billancourt', 'Saint-Denis', 'Montreuil', 'Argenteuil', 'Nanterre', 'Créteil', 'Versailles', 'Aubervilliers']
  },
  { 
    id: 'marseille', 
    name: 'Marseille',
    slug: 'marseille',
    surroundingCities: ['Aix-en-Provence', 'Aubagne', 'Martigues', 'Salon-de-Provence', 'Istres', 'Vitrolles', 'Marignane', 'La Ciotat']
  },
  { 
    id: 'lyon', 
    name: 'Lyon',
    slug: 'lyon',
    surroundingCities: ['Villeurbanne', 'Vénissieux', 'Caluire-et-Cuire', 'Saint-Priest', 'Vaulx-en-Velin', 'Bron', 'Meyzieu', 'Rillieux-la-Pape']
  },
  { 
    id: 'toulouse', 
    name: 'Toulouse',
    slug: 'toulouse',
    surroundingCities: ['Blagnac', 'Colomiers', 'Tournefeuille', 'Muret', 'Balma', 'Ramonville-Saint-Agne', 'Cugnaux', 'Plaisance-du-Touch']
  },
  { 
    id: 'nantes', 
    name: 'Nantes',
    slug: 'nantes',
    surroundingCities: ['Saint-Herblain', 'Rezé', 'Saint-Nazaire', 'Orvault', 'Vertou', 'Carquefou', 'Bouguenais', 'La Chapelle-sur-Erdre']
  },
  { 
    id: 'bordeaux', 
    name: 'Bordeaux',
    slug: 'bordeaux',
    surroundingCities: ['Mérignac', 'Pessac', 'Talence', 'Bègles', 'Villenave-d\'Ornon', 'Cenon', 'Floirac', 'Eysines']
  },
  { 
    id: 'nice', 
    name: 'Nice',
    slug: 'nice',
    surroundingCities: ['Antibes', 'Cannes', 'Grasse', 'Cagnes-sur-Mer', 'Saint-Laurent-du-Var', 'Menton', 'Vence', 'Villeneuve-Loubet']
  },
  { 
    id: 'montpellier', 
    name: 'Montpellier',
    slug: 'montpellier',
    surroundingCities: ['Nîmes', 'Béziers', 'Sète', 'Lunel', 'Castelnau-le-Lez', 'Lattes', 'Pérols', 'Mauguio']
  },
  { 
    id: 'lille', 
    name: 'Lille',
    slug: 'lille',
    surroundingCities: ['Roubaix', 'Tourcoing', 'Villeneuve-d\'Ascq', 'Dunkerque', 'Wattrelos', 'Marcq-en-Barœul', 'Lambersart', 'Mons-en-Barœul']
  },
  { 
    id: 'cannes', 
    name: 'Cannes',
    slug: 'cannes',
    surroundingCities: ['Antibes', 'Grasse', 'Le Cannet', 'Mandelieu-la-Napoule', 'Mougins', 'Vallauris', 'Nice', 'Juan-les-Pins']
  },
  { 
    id: 'nimes', 
    name: 'Nîmes',
    slug: 'nimes',
    surroundingCities: ['Alès', 'Beaucaire', 'Arles', 'Montpellier', 'Vauvert', 'Marguerittes', 'Milhaud', 'Caissargues']
  },
  { 
    id: 'annemasse', 
    name: 'Annemasse',
    slug: 'annemasse',
    surroundingCities: ['Genève', 'Thonon-les-Bains', 'Annecy', 'Cluses', 'Bonneville', 'Ville-la-Grand', 'Gaillard', 'Ambilly']
  },
  { 
    id: 'rennes', 
    name: 'Rennes',
    slug: 'rennes',
    surroundingCities: ['Saint-Malo', 'Fougères', 'Vitré', 'Cesson-Sévigné', 'Bruz', 'Pacé', 'Chantepie', 'Saint-Grégoire']
  },
  { 
    id: 'toulon', 
    name: 'Toulon',
    slug: 'toulon',
    surroundingCities: ['La Seyne-sur-Mer', 'Hyères', 'Six-Fours-les-Plages', 'La Garde', 'Sanary-sur-Mer', 'Ollioules', 'La Valette-du-Var', 'Le Pradet']
  },
  { 
    id: 'saint-etienne', 
    name: 'Saint-Étienne',
    slug: 'saint-etienne',
    surroundingCities: ['Firminy', 'Roanne', 'Montbrison', 'Rive-de-Gier', 'Saint-Chamond', 'Andrézieux-Bouthéon', 'Roche-la-Molière', 'Le Chambon-Feugerolles']
  },
  { 
    id: 'angers', 
    name: 'Angers',
    slug: 'angers',
    surroundingCities: ['Cholet', 'Saumur', 'Avrillé', 'Trélazé', 'Les Ponts-de-Cé', 'Saint-Barthélemy-d\'Anjou', 'Beaucouzé', 'Bouchemaine']
  },
  { 
    id: 'le-havre', 
    name: 'Le Havre',
    slug: 'le-havre',
    surroundingCities: ['Montivilliers', 'Gonfreville-l\'Orcher', 'Sainte-Adresse', 'Harfleur', 'Octeville-sur-Mer', 'Fécamp', 'Étretat', 'Honfleur']
  },
  { 
    id: 'grenoble', 
    name: 'Grenoble',
    slug: 'grenoble',
    surroundingCities: ['Échirolles', 'Saint-Martin-d\'Hères', 'Fontaine', 'Voiron', 'Vienne', 'Meylan', 'Seyssinet-Pariset', 'Sassenage']
  },
  { 
    id: 'strasbourg', 
    name: 'Strasbourg',
    slug: 'strasbourg',
    surroundingCities: ['Schiltigheim', 'Illkirch-Graffenstaden', 'Lingolsheim', 'Bischheim', 'Hoenheim', 'Ostwald', 'Eckbolsheim', 'Geispolsheim']
  },
  { 
    id: 'nancy', 
    name: 'Nancy',
    slug: 'nancy',
    surroundingCities: ['Vandœuvre-lès-Nancy', 'Laxou', 'Villers-lès-Nancy', 'Lunéville', 'Toul', 'Pont-à-Mousson', 'Jarville-la-Malgrange', 'Maxéville']
  },
  { 
    id: 'dijon', 
    name: 'Dijon',
    slug: 'dijon',
    surroundingCities: ['Chenôve', 'Talant', 'Quetigny', 'Beaune', 'Chevigny-Saint-Sauveur', 'Longvic', 'Fontaine-lès-Dijon', 'Marsannay-la-Côte']
  },
  { 
    id: 'tours', 
    name: 'Tours',
    slug: 'tours',
    surroundingCities: ['Joué-lès-Tours', 'Saint-Cyr-sur-Loire', 'Saint-Pierre-des-Corps', 'Chambray-lès-Tours', 'Amboise', 'Blois', 'La Riche', 'Ballan-Miré']
  },
  { 
    id: 'clermont-ferrand', 
    name: 'Clermont-Ferrand',
    slug: 'clermont-ferrand',
    surroundingCities: ['Chamalières', 'Cournon-d\'Auvergne', 'Riom', 'Beaumont', 'Aubière', 'Gerzat', 'Cébazat', 'Romagnat']
  }
];

export const services = [
  {
    id: 1,
    title: 'Retour Affectif Rapide',
    description: 'Faire revenir son ex rapidement avec des rituels puissants. Retour affectif garanti sous 7 jours. Récupérez l\'être aimé définitivement.',
    icon: '💕'
  },
  {
    id: 2,
    title: 'Faire Revenir Son Ex',
    description: 'Rituels efficaces pour faire revenir son ex-mari, ex-femme, ex-copain ou ex-copine. Résultats garantis en 3 à 7 jours maximum.',
    icon: '❤️'
  },
  {
    id: 3,
    title: 'Récupérer Son Ex',
    description: 'Comment récupérer son ex après une rupture ? Mes rituels de marabout puissant vous aident à reconquérir votre ex définitivement.',
    icon: '💍'
  },
  {
    id: 4,
    title: 'Envoûtement Amoureux',
    description: 'Rituels d\'envoûtement puissant pour attirer la personne désirée. Marabout efficace avec résultats rapides et durables.',
    icon: '🔮'
  },
  {
    id: 5,
    title: 'Désenvoûtement Rapide',
    description: 'Libérez-vous des mauvais sorts et malédictions. Marabout puissant pour désenvoûtement immédiat et protection spirituelle.',
    icon: '✨'
  },
  {
    id: 6,
    title: 'Protection Spirituelle',
    description: 'Protection complète contre le mauvais œil, jalousie et sorcellerie. Marabout efficace disponible 24/7 pour vous protéger.',
    icon: '🛡️'
  },
  {
    id: 7,
    title: 'Voyance Sérieuse',
    description: 'Consultations de voyance sérieuse et précise. Voyant médium authentique pour connaître votre avenir amoureux et professionnel.',
    icon: '🔯'
  },
  {
    id: 8,
    title: 'Mariage & Fidélité',
    description: 'Rituels pour mariage rapide et fidélité du partenaire. Marabout puissant pour consolider votre union amoureuse.',
    icon: '🌟'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sophie M.',
    city: 'Marseille',
    message: 'Mon ex est revenu après seulement 7 jours ! Je ne peux que remercier Maître pour son travail exceptionnel. Un vrai marabout sérieux !',
    rating: 5,
    date: '2 jours'
  },
  {
    id: 2,
    name: 'Jean-Pierre L.',
    city: 'Lyon',
    message: 'Après 3 ans de séparation, je pensais que tout était perdu. Grâce aux rituels de Maître, nous sommes à nouveau ensemble et plus amoureux que jamais. MERCI ! 🙏',
    rating: 5,
    date: '5 jours'
  },
  {
    id: 3,
    name: 'Nathalie D.',
    city: 'Paris',
    message: 'J\'étais sceptique au début, mais les résultats sont là ! Mon mari est revenu à la maison en moins de 2 semaines. Un grand marabout voyant !',
    rating: 5,
    date: '1 semaine'
  },
  {
    id: 4,
    name: 'Ahmed B.',
    city: 'Toulouse',
    message: 'Protection efficace contre le mauvais œil. Ma situation professionnelle s\'est améliorée immédiatement. Je recommande à 100% !',
    rating: 5,
    date: '3 jours'
  },
  {
    id: 5,
    name: 'Marie C.',
    city: 'Nice',
    message: 'Un vrai médium ! Il a vu des choses que personne ne savait. Son rituel de retour affectif a fonctionné en 10 jours. Incroyable ! ❤️',
    rating: 5,
    date: '1 jour'
  },
  {
    id: 6,
    name: 'David R.',
    city: 'Nantes',
    message: 'Désenvoûtement réussi ! Je me sens libéré et ma vie a complètement changé. Maître est un vrai professionnel, sérieux et compétent.',
    rating: 5,
    date: '4 jours'
  },
  {
    id: 7,
    name: 'Fatima K.',
    city: 'Bordeaux',
    message: 'Mon mariage était en danger, maintenant tout va bien grâce aux rituels. Mon mari est redevenu comme avant. Merci infiniment ! 💕',
    rating: 5,
    date: '2 semaines'
  },
  {
    id: 8,
    name: 'Christophe M.',
    city: 'Montpellier',
    message: 'Voyance très précise ! Tout ce qu\'il m\'a dit s\'est réalisé. Un grand marabout africain authentique et honnête.',
    rating: 5,
    date: '6 jours'
  },
  {
    id: 9,
    name: 'Isabelle T.',
    city: 'Lille',
    message: 'Résultats spectaculaires en 5 jours ! Mon ex m\'a appelée en pleurant pour me supplier de revenir. C\'est magique ! Merci Maître ! ✨',
    rating: 5,
    date: '1 jour'
  },
  {
    id: 10,
    name: 'Mohamed A.',
    city: 'Strasbourg',
    message: 'Je recommande vivement ! Rituel de protection très puissant. Plus aucun problème depuis la consultation. Un grand maître spirituel.',
    rating: 5,
    date: '1 semaine'
  },
  {
    id: 11,
    name: 'Céline B.',
    city: 'Rennes',
    message: 'Mon couple était brisé depuis 6 mois. En 2 semaines, nous nous sommes remariés ! C\'est un miracle, je n\'y croyais plus. Merci du fond du cœur ! 💖',
    rating: 5,
    date: '3 jours'
  },
  {
    id: 12,
    name: 'Patrick D.',
    city: 'Toulon',
    message: 'Retour d\'affection garanti ! Ma femme qui était partie avec un autre est revenue me supplier. Incroyable efficacité. Le meilleur marabout !',
    rating: 5,
    date: '2 jours'
  }
];

// Fonction pour obtenir les initiales et couleur
export const getTestimonialAvatar = (name) => {
  const initials = name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  const colors = [
    'from-blue-500 to-blue-700',
    'from-purple-500 to-purple-700',
    'from-pink-500 to-pink-700',
    'from-orange-500 to-orange-700',
    'from-teal-500 to-teal-700',
    'from-indigo-500 to-indigo-700',
  ];
  const colorIndex = name.charCodeAt(0) % colors.length;
  return { initials, gradient: colors[colorIndex] };
};

export const phoneNumber = '+33745449641';
export const whatsappNumber = '33745449641';
export const whatsappLink = `https://wa.me/${whatsappNumber}`;

export const siteInfo = {
  title: 'Marabout Sérieux - Voyant Médium Africain',
  description: 'Grand marabout sérieux et voyant médium africain reconnu. Retour affectif rapide, retour de l\'être aimé, mariage, protection. Résultats garantis.',
  email: 'contact@maraboutserieux.com',
  domain: 'maraboutserieux.com'
};

export const faqData = [
  {
    question: "Comment faire revenir son ex rapidement et efficacement ?",
    answer: "Pour faire revenir son ex, Le Grand Marabout pratique des rituels de retour affectif puissants qui agissent rapidement. En tant que marabout efficace, il utilise la magie rouge et des incantations ancestrales qui créent un lien spirituel irrésistible. Que vous vouliez récupérer votre ex-mari, ex-femme, ex-copain ou ex-copine, ses rituels de marabout puissant fonctionnent même dans les cas les plus difficiles. Le retour affectif rapide inclut : analyse voyance gratuite, rituel personnalisé, suivi quotidien, et résultats visibles sous 7 jours. Plus de 2400 personnes ont réussi à faire revenir leur ex grâce à ses services."
  },
  {
    question: "Est-ce que le retour affectif rapide fonctionne vraiment ?",
    answer: "Oui ! Le retour affectif rapide du Grand Marabout est garanti sous 7 jours selon la complexité de votre situation. C'est un marabout puissant reconnu avec 25 ans d'expérience. Ses rituels pour faire revenir son ex combinent magie africaine traditionnelle, voyance sérieuse et énergies cosmiques. Les premiers signes apparaissent dès les premiers jours : rêves, pensées obsessionnelles de votre ex, messages WhatsApp ou SMS. Votre ex ressent un besoin irrésistible de vous recontacter. Son taux de réussite est de 98%. Si aucun résultat après 7 jours, il continue gratuitement jusqu'à satisfaction complète."
  },
  {
    question: "Quelle est la différence entre Le Grand Marabout et les autres marabouts ?",
    answer: "Contrairement aux charlatans, Le Grand Marabout est un VRAI marabout puissant avec une lignée familiale de grands marabouts africains. Il est le marabout efficace le plus recommandé en France car : 1) Première consultation gratuite, 2) Résultats garantis, 3) Retour affectif rapide garanti sous 7 jours, 4) Plus de 2400 clients satisfaits avec témoignages vérifiés, 5) Disponible 24h/24 et 7j/7, 6) Voyance sérieuse pour analyser votre situation avant tout rituel, 7) Discrétion absolue garantie. Il est spécialisé dans faire revenir son ex, récupérer l'être aimé, et tous les problèmes sentimentaux."
  },
  {
    question: "Comment récupérer son ex après une rupture difficile ?",
    answer: "Récupérer son ex après une rupture difficile est la spécialité du Grand Marabout. Même si votre ex est avec quelqu'un d'autre, même après des années de séparation, ses rituels fonctionnent. Pour récupérer votre ex, il combine : rituel de retour affectif rapide, envoûtement amoureux, désenvoûtement si nécessaire, et voyance sérieuse. Le processus : 1) Vous le contactez gratuitement, 2) Il analyse votre situation avec sa voyance, 3) Il choisit le rituel le plus puissant, 4) Résultats sous 7 jours. Que vous vouliez récupérer votre ex-mari, ex-femme ou ex-partenaire, ses rituels de marabout efficace agissent rapidement."
  },
  {
    question: "Puis-je consulter Le Grand Marabout si j'habite loin ?",
    answer: "Oui, absolument ! Le Grand Marabout est un marabout efficace qui travaille à distance pour tous ses clients en France et à l'international. Les rituels de retour affectif rapide pour faire revenir son ex n'ont pas de frontières physiques. Que vous soyez à Paris, Marseille, Lyon ou ailleurs, l'efficacité de son travail de marabout puissant reste identique. Une simple consultation téléphonique ou WhatsApp suffit pour commencer votre rituel pour récupérer votre ex. Ses rituels agissent sur le plan spirituel, donc la distance n'affecte jamais les résultats. Des milliers de clients à travers toute la France ont fait revenir leur ex grâce à sa voyance sérieuse et ses rituels à distance."
  },
  {
    question: "Combien coûtent les services du Grand Marabout ?",
    answer: "En tant que marabout efficace, les tarifs du Grand Marabout varient selon la complexité de votre situation et le type de rituel nécessaire (retour affectif rapide, faire revenir son ex, récupérer son ex, etc.). La première consultation est entièrement gratuite pour évaluer votre cas avec sa voyance sérieuse. Il vous donne un devis clair et honnête avant de commencer tout travail. Les résultats sont garantis. Il propose également des facilités de paiement. L'important pour lui est votre satisfaction. C'est un marabout puissant sérieux, pas un charlatan qui demande des sommes énormes sans garantie."
  },
  {
    question: "Quels problèmes de couple Le Grand Marabout peut-il résoudre ?",
    answer: "En tant que marabout puissant et efficace, Le Grand Marabout résout tous types de problèmes sentimentaux : faire revenir son ex (ex-mari, ex-femme, ex-copain, ex-copine), récupérer son ex après rupture difficile, retour affectif rapide, retour de l'être aimé, reconquérir son ex, envoûtement amoureux pour attirer quelqu'un, fidélité du partenaire, mariage rapide, sauver son couple en crise, empêcher un divorce, faire revenir son conjoint parti, éloigner un rival(e), désenvoûtement amoureux, protection contre mauvais œil et jalousie. Sa voyance sérieuse lui permet d'identifier rapidement la source du problème et d'appliquer le rituel de marabout le plus puissant et efficace pour votre situation."
  },
  {
    question: "Les rituels de marabout sont-ils dangereux ou ont-ils des effets secondaires ?",
    answer: "Non, les rituels du Grand Marabout sont sans danger et sans effets secondaires négatifs. C'est un marabout efficace et sérieux qui travaille uniquement avec des énergies positives et bienveillantes. Il ne pratique JAMAIS de magie noire ou de rituels maléfiques. Tous ses rituels pour faire revenir son ex, récupérer son ex, ou retour affectif rapide sont faits dans le respect des lois spirituelles et de l'éthique. Les résultats sont durables et bénéfiques pour tous. Avec sa voyance sérieuse, il utilise la magie blanche et rouge (amour) qui ne causent aucun mal. Vous ne risquez absolument rien en faisant appel à ses services de marabout puissant. Des milliers de clients ont réussi à faire revenir leur ex sans aucun problème."
  }
];
